import { useGeneratedPriceQuotesSavedListQuery } from '@/experiences/sales-portal/domain/pricing/screens/quotes/blocs/documents/price-quotes-saved-list.generated';
import { useMemo } from 'react';

export interface PriceQuoteSummary {
  accountName: string;
  currencyCode: string;
  itemCount: number;
  name: string;
  priceQuoteId: string;
  totalAmountInMicros: number;
  updatedAt: string;
}

interface UseSavedQuotesLoaderResult {
  loading: boolean;
  savedQuotes: PriceQuoteSummary[];
}

/**
 * Loads saved-quote summaries for the dropdown list. Scoped to the
 * distributor org; ordering is whatever the backend returns.
 */
export const useSavedQuotesLoader = (
  businessOrganizationUUID: string,
): UseSavedQuotesLoaderResult => {
  const { data, loading } = useGeneratedPriceQuotesSavedListQuery({
    fetchPolicy: 'cache-and-network',
    variables: { businessOrganizationUUID },
  });

  const savedQuotes = useMemo<PriceQuoteSummary[]>(() => {
    if (!data) {
      return [];
    }
    return data.getPriceQuotes.map((q) => ({
      accountName: q.account_name,
      currencyCode: q.currency_code,
      itemCount: q.item_count,
      name: q.name,
      priceQuoteId: q.price_quote_id,
      totalAmountInMicros: q.total_amount_in_micros,
      updatedAt: q.updated_at,
    }));
  }, [data]);

  return { loading, savedQuotes };
};
